// 灯塔子应用 URL 前缀
export const SUB_APP_PREFIX = "/rss";

// 权限 code： 0-默认，1-无权限，2-有权限
export const PERMISSION_CODE = {
  DEFAULT: 0,
  NO_PERMISSION: 1,
  HAS_PERMISSION: 2,
};

// 菜单请求参数：0-前端，1-八角，2-朝天椒，3-灯塔
export const FROM_SIDE = {
  FE: 0,
  BA_JIAO: 1,
  CHAO_TIAN_JIAO: 2,
  DENG_TA: 3,
};

// 1 whole menu，2 header menu, 3 whole menu + header menu
export const FILTER_WORD = {
  WHOLE_MENU: 1,
  HEADER_MENU: 2,
  ALL_MENU: 3,
};

export const PAGE_LOGIN = "/page/login.html";
